<template>
  <v-card color="blue-grey" class="white--text" >    

    <v-card-title primary-title>
      <div>
        <div class="headline">Documento de la comunidad</div>
        <div class='pt-2'><strong>{{ getDescripcion() }}</strong> - {{ getAmpliacion() }}</div>
      </div>
    </v-card-title>
    <div class="pa-2">
      <pdf-viewer :pdfPath='getUrl()'></pdf-viewer> 
    </div>
  </v-card>
     
</template>

<style>

</style>

<script>
import PdfViewer from './ver-pdf'

import { mapState } from 'vuex'

export default {
    name: 'VerFacturaLiquidacion',
    props: {
      'idLiquidacion': { type: Number, required: true },
      'idDetalle': { type: Number, required: true },
      'idDocumento': { type: Number, required: true}
    },
    components: {
      PdfViewer
    },
    methods: {
        getUrl() {
            var detalle = this.detalles.find((detalle) => {
              return detalle.ID == this.idDetalle
            });

            var documento = detalle.DOCUMENTOS.find((documento) => {
              return documento.IDDOCUMENTO = this.idDocumento
            })

            return documento.URL
        },
        getDescripcion() {
            var detalle = this.detalles.find((detalle) => {
              return detalle.ID == this.idDetalle
            });

            return detalle.DESCRIPCION
        },
        getAmpliacion() {
            var detalle = this.detalles.find((detalle) => {
              return detalle.ID == this.idDetalle
            });

            return detalle.AMPLIACION
        }
    },
    computed: {
      ...mapState({
        detalles: state => state.liquidaciones.detalle_liquidacion
      })
    }
}
</script>

